import { TableCellProps, Td } from "@chakra-ui/react"
import styled from "@emotion/styled"
import React from "react"

type TruncatedTextProps = {
    isSelected?: boolean
    isEven?: boolean
} & React.HTMLAttributes<HTMLSpanElement>

export const TruncatedText = styled(({ isEven, isSelected, ...props }: TruncatedTextProps) => (
    <span {...props} />
))`
    background-color: ${({ isSelected, isEven }) => (isSelected ? 'var(--chakra-colors-selected-row-background)' : isEven ? 'var(--chakra-colors-background)' : 'var(--chakra-colors-odd-background)')};
    
    padding-top: var(--chakra-space-2);
    padding-bottom: var(--chakra-space-2);

    :hover {
       box-shadow: inset -7px 0 9px -7px rgb(0 0 0 / 70%);
       padding-right: var(--chakra-space-2);
       border-radius: 3px;
    }
`

const truncatedCellStyle: TableCellProps = {
    _hover: {
        overflow: 'visible',
        zIndex: 2,
        position: 'relative'
    },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
}

type TruncatedTableCellProps = {
    isSelected?: boolean
    isEven?: boolean
    isTruncate?: boolean
} & React.HTMLAttributes<HTMLTableCellElement>

export const TruncatedTableCell = (WrappedComponent: React.ComponentType) =>
    ({ children, isEven, isSelected, isTruncate, ...props }: TruncatedTableCellProps) => (
        <WrappedComponent 
            {...(isTruncate && truncatedCellStyle)}
        >
            {
                isTruncate
                    ? <TruncatedText isEven={isEven} isSelected={isSelected}>{children}</TruncatedText>
                    : children
            }
        </WrappedComponent>
    )

export const TruncatedTd = TruncatedTableCell(Td)